import axios from './axios';

export const partialUpdate = (userId: number, userAttrs: {}) => {
  return axios.put(`/auth/partial-update/${userId}`, userAttrs).then(res => res.data);
};

export default {};
